import {Article, PositionSource} from "@/model/Article";
import {Functions} from "@/plugins/Functions";

export const MAX_AI_KEYWORDS = 20;

function textOf(value: unknown): string {
    return String(value || '').trim();
}

function headingHasText(parts: unknown): boolean {
    if (!Array.isArray(parts) || !parts.length) {
        return false;
    }
    const first = parts[0] as {h?: unknown, p?: unknown};
    return !!(textOf(first?.h) || textOf(first?.p));
}

/** Article already has writing payload even if selectedKeyword was never persisted. */
export function articleHasWritingContent(article: Article | null | undefined): boolean {
    if (!article) {
        return false;
    }
    if (textOf(article.metaTitle) || textOf(article.metaDescription)) {
        return true;
    }
    if (headingHasText(article.h1)) {
        return true;
    }
    if (Array.isArray(article.allKeywords) && article.allKeywords.some((row) => textOf(row?.keyword))) {
        return true;
    }
    if (Array.isArray(article.questions) && article.questions.some((row) => textOf(row?.question) || textOf(row?.answer))) {
        return true;
    }
    return !!article.ai_content_last_generated_at;
}

/**
 * If Lucy already wrote (or the article has density rows) but selectedKeyword
 * is empty, copy keyword into selectedKeyword without starting a new generate.
 */
export function healMissingSelectedKeyword(article: Article): boolean {
    if (textOf(article.selectedKeyword) || !articleHasWritingContent(article)) {
        return false;
    }
    const keyword = textOf(article.keyword);
    if (!keyword) {
        return false;
    }
    article.selectedKeyword = keyword;
    return true;
}

export function findLastNonEmptyIndex<T>(
  arr: T[],
  extractor: (item: T) => string[]
): number {
  for (let i = arr.length - 1; i >= 0; i--) {
    const fields = extractor(arr[i]);
    if (fields.some(f => f.trim() !== "")) {
      return i;
    }
  }
  return -1;
}

export const articlePositionSources = {
    [PositionSource.GOOGLE_AIO]: {
        field: 'googleAIOPosition',
        fetch: (articleId: string) => Functions.D4SGetGoogleAIOPosition({article_id: articleId})
    },
    [PositionSource.GOOGLE]: {
        field: 'organicPosition',
        fetch: (articleId: string) => Functions.D4SGetOrganicPosition({article_id: articleId})
    },
    [PositionSource.CHAT_GPT]: {
        field: 'chatGPTPosition',
        fetch: (articleId: string) => Functions.D4SGetChatGPTPosition({article_id: articleId})
    }
} as const;
